import React, { useState } from 'react';
import { useDrag } from 'react-dnd';
import { useApp } from '../contexts/AppContext';
import { Skill } from '../types';
import { SkillIcon } from './SkillIcon';
import { SkillTooltip } from './SkillTooltip';

interface DraggableSkillProps {
  skill: Skill;
  onMouseEnter: (event: React.MouseEvent, skill: Skill) => void;
  onMouseLeave: () => void;
}

const DraggableSkill: React.FC<DraggableSkillProps> = ({ skill, onMouseEnter, onMouseLeave }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'skill',
    item: { skill },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={drag as any}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
        padding: '4px'
      }}
    >
      <SkillIcon 
        skill={skill} 
        size={40} 
        showDetailedTooltip={true}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </div>
  );
};

export const SkillPanel: React.FC = () => {
  const { state } = useApp();
  const [tooltip, setTooltip] = useState<{
    skill: Skill;
    x: number;
    y: number;
    visible: boolean;
  }>({
    skill: {} as Skill,
    x: 0,
    y: 0,
    visible: false
  });

  if (!state.currentJob) {
    return null;
  }

  const handleMouseEnter = (event: React.MouseEvent, skill: Skill) => {
    setTooltip({
      skill,
      x: event.clientX,
      y: event.clientY,
      visible: true
    });
  };

  const handleMouseLeave = () => {
    setTooltip(prev => ({ ...prev, visible: false }));
  };

  const allSkills = state.currentJob.skills;

  return (
    <div style={{
      backgroundColor: '#2a2a2a',
      borderRadius: '8px',
      padding: '16px',
      border: '1px solid #444',
      maxHeight: '60vh',
      overflowY: 'auto'
    }}>
      <h3 style={{ color: '#f0f0f0', marginBottom: '12px' }}>技能列表</h3>
      
      <div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(48px, 1fr))',
          gap: '4px'
        }}>
          {allSkills.map(skill => (
            <DraggableSkill 
              key={skill.id} 
              skill={skill} 
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          ))}
        </div>
      </div>

      {/* 技能详情对话框 */}
      <SkillTooltip
        skill={tooltip.skill}
        visible={tooltip.visible}
        x={tooltip.x}
        y={tooltip.y}
        jobGcd={state.currentJob?.gcd || 2.5}
      />
    </div>
  );
};